import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type DeleteTemplateModalProps = {
	readonly onClose: () => void;
	readonly onConfirm: () => void;
	readonly templateName: string;
};

export function DeleteTemplateModal({
	onClose,
	onConfirm,
	templateName,
}: DeleteTemplateModalProps) {
	return (
		<TraxModal
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={"Delete Template"}
			type={"confirmation"}
		>
			<p>
				Are you sure you want to delete the template{" "}
				<strong>{templateName}</strong>?
			</p>
		</TraxModal>
	);
}
